import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, closeDrawer, getURLSegment } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Dependencies
import Phone, { isValidPhoneNumber } from 'react-phone-number-input';
import DatePicker from 'react-datepicker';
import moment from 'moment';

// Components
import TimeSelect2 from '../Modules/TimeSelect2';
import Map from '../Map/Map';

const EditProctor = observer(class EditProctor extends React.Component {
  constructor() {
    super();
    this.handleDateChange = this.handleDateChange.bind(this);
    this.updateDates = this.updateDates.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
    this.handlePhoneInput = this.handlePhoneInput.bind(this);
    this.setLocation = this.setLocation.bind(this);
  }

  componentWillMount() {
    this.state = {
      examSid: null,
      enrollmentSid: null,
      proctorData: {
        firstName: '',
        lastName: '',
        company: '',
        email: '',
        phone: '',
        appointmentDateTime: null,
        address1: null,
        address2: null,
        place: null,
        region: null,
        country: null,
        locationLatitude: null,
        locationLongitude: null,
        postalCode: null
      }
    };

    const examSid = getURLSegment(this, 2);
    const enrollmentSid = this.props.routing.location.query.enrollment;
    const sessionSid = this.props.routing.location.query.session;

    this.setState({
      examSid,
      enrollmentSid,
      sessionSid
    });

    const _this = this;
    setTimeout(function(){
      _this.getSession();
    })
  }

  getSession() {
    this.props.store.EnrollmentStore.getExamSession(this.state.examSid, this.state.sessionSid, this);
  }

  handleInput() {
    let proctorData = { ...this.state.proctorData };

    proctorData.firstName = this.firstName.value;
    proctorData.lastName = this.lastName.value;
    proctorData.company = this.company.value;
    proctorData.email = this.email.value;
    // proctorData.phone = this.phone.props.value;

    this.setState({
      proctorData
    });
  }

  handleDateChange(date, isDateField) {
    if(isDateField) {
      let proctorData = {...this.state.proctorData};

      proctorData.appointmentDateTime = date;

      this.setState({
        proctorData
      });
    } else {
      date = this.state.proctorData.appointmentDateTime;
    }

    const time = this.time.value;

    // Update form data
    const _this = this;
    setTimeout(function(){
      _this.updateDates(date, time);
    })
  }

  updateDates(date, time) {
    const { userTimezone } = this.props.store.SessionStore;
    const dateString = moment(date).format('YYYY-MM-DD');
    const timezoneString = moment(date).tz(userTimezone).format('Z');
    const appointmentDateTime = moment.utc(`${dateString} ${time} ${timezoneString}`, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();

    let proctorData = {...this.state.proctorData};
    proctorData.appointmentDateTime = appointmentDateTime;

    this.setState({
      proctorData
    });
  }

  handlePhoneInput(e) {
    let proctorData = {...this.state.proctorData};
    proctorData.phone = e;
    this.setState({
      proctorData
    });
  }

  handleSubmit(e) {
    const data = {...this.state.proctorData};

    data.type = 'ad-hoc';

    Object.keys(data).forEach(function(prop){
      if(!data[prop]) {
        delete data[prop]
      }
    });

    delete data.accountName;

    this.props.store.ScheduleStore.rescheduleAppointment(this.state.examSid, this.state.sessionSid, data, this.complete);
  }

  complete() {
    // Get url segments
    const examSid = getURLSegment(this, 2);

    const closePath = `${getURLSegment(this, 1)}/${examSid}`;

    closeDrawer(null, this.props.parent, closePath);
    this.props.store.SessionStore.showToaster(this.props.translation.proctor_assigned, 'success');

    // Update the roster table
    this.props.store.ExamStore.getEnrollments(examSid);
  }

  setLocation(name, address1, address2, place, region, country, postalCode, lat, lng, preventRender) {
    let proctorData = {...this.state.proctorData};

    proctorData.address1 = address1;
    proctorData.address2 = address2;
    proctorData.place = place;
    proctorData.region = region;
    proctorData.country = country;
    proctorData.postalCode = postalCode;
    proctorData.locationLatitude = lat.toString();
    proctorData.locationLongitude = lng.toString();

    this.setState({
      proctorData
    });
  }

  renderLocation() {
    const { proctorData } = this.state;

    // Default map options
    const center = {
      lat: this.state.proctorData.locationLatitude || 37.09024,
      lng: this.state.proctorData.locationLongitude || -95.712891
    }

    let zoom = 4;
    let dropPin = false;

    if(this.state.proctorData.locationLatitude && this.state.proctorData.locationLongitude) {
      zoom = 17;
      dropPin = true;
    }

    let location = '';

    if(proctorData.address1) {
      location = proctorData.address1 + ', ';
    }

    if(proctorData.address2) {
      location += proctorData.address2 + ', ';
    }

    if(proctorData.place) {
      location += proctorData.place + ', ';
    }

    if(proctorData.region) {
      location += proctorData.region + ' ';
    }

    if(proctorData.postalCode) {
      location += proctorData.postalCode;
    }

    return (
      <fieldset className="form-section">
        <Map
          setLocation={this.setLocation}
          store={this.props.store}
          center={center}
          zoom={zoom}
          dropPin={dropPin}
          default={location}
          locationSet={this.state.proctorData.locationLatitude ? true : false}
          requireAddress={true}
        />
      </fieldset>
    )
  }

  render() {
    const { translation } = this.props;
    const { examSession } = this.props.store.EnrollmentStore;
    const { userTimezone } = this.props.store.SessionStore;

    if(typeof examSession.proctor !== 'undefined' && examSession.proctor.company) {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>

          <div className="wrap block-form">
            <form onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
              <fieldset id="exam-details" className="panel">
                <div className="panel__body">
                  <ul className="fields">
                    <li className="field--half">
                      <label className="lbl-required" htmlFor="proctor-fname">First Name</label>
                      <input
                        type="text"
                        id="proctor-fname"
                        placeholder="The proctor’s first name…"
                        ref={(input) => { this.firstName = input }}
                        onChange={this.handleInput}
                        defaultValue={examSession.proctor.firstName}
                        required
                        aria-required="true"
                        autoFocus
                      />
                    </li>
                    <li className="field--half">
                      <label className="lbl-required" htmlFor="proctor-lname">Last Name</label>
                      <input
                        type="text"
                        id="proctor-lname"
                        placeholder="The proctor’s last name…"
                        ref={(input) => { this.lastName = input }}
                        onChange={this.handleInput}
                        defaultValue={examSession.proctor.lastName}
                        required
                        aria-required="true"
                      />
                    </li>
                    <li>
                      <label className="lbl-required" htmlFor="proctor-company">Company</label>
                      <input
                        type="text"
                        id="proctor-company"
                        placeholder="The company the proctor works for…"
                        ref={(input) => { this.company = input }}
                        onChange={this.handleInput}
                        defaultValue={examSession.proctor.company}
                        required
                        aria-required="true"
                      />
                    </li>
                    <li className="field--half">
                      <label className="lbl-required" htmlFor="proctor-email">Email</label>
                      <input
                        type="email"
                        id="proctor-email"
                        placeholder="email@example.com"
                        ref={(input) => { this.email = input }}
                        onChange={this.handleInput}
                        defaultValue={examSession.proctor.email}
                        required
                        aria-required="true"
                      />
                    </li>
                    <li className="field--half">
                      <label className="lbl-required" htmlFor="proctor-phone">Phone</label>
                      <Phone
                        id="proctor-phone"
                        nativeExpanded={true}
                        flagsPath="./static/img/flags/"
                        value={this.state.proctorData.phone}
                        ref={(input) => { this.phone = input }}
                        onChange={e => this.handlePhoneInput(e)}
                        required
                        aria-required="true"
                        aria-invalid={!isValidPhoneNumber(this.state.proctorData.phone)}
                      />
                    </li>
                    <li className="field--auto">
                      <label className="lbl-required" htmlFor="proctor-date">Date and Time</label>
                      <DatePicker
                        id="proctor-date"
                        selected={this.state.proctorData.appointmentDateTime ? moment(this.state.proctorData.appointmentDateTime).tz(userTimezone) : null}
                        openToDate={moment(examSession.examConfiguration.examOpenDate)}
                        minDate={examSession.examConfiguration.examOpenDate}
                        maxDate={examSession.examConfiguration.examCloseDate}
                        onChange={(date) => {this.handleDateChange(date, true)}}
                        ref={(input) => {this.appointmentDateTime = input}}
                        placeholderText="mm/dd/yyyy"
                        required
                        aria-required="true"
                        autoComplete="off"
                      />

                      <span className="preposition">at</span>

                      <label className="select">
                        <select
                          id="proctor-time"
                          ref={(input) => {this.time = input}}
                          onChange={() => this.handleDateChange(null, false)}
                          value={moment.utc(this.state.proctorData.appointmentDateTime).tz(userTimezone).format('HH:mm')}
                        >
                          <TimeSelect2 />
                        </select>
                      </label>

                      <span className="preposition">
                        {/* If a date is selected, use that date’s dst */}
                        {this.state.appointmentDateTime &&
                          moment.utc(this.state.appointmentDateTime).tz(userTimezone).format('z')
                        }

                        {/* Otherwise use the current date’s dst */}
                        {!this.state.appointmentDateTime &&
                          moment().tz(userTimezone).format('z')
                        }
                      </span>
                    </li>
                  </ul>

                  {this.renderLocation()}

                  <div className="panel__actions actions">
                    <button className="actions__btn actions__btn--primary">Submit</button>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('EditProctor')(EditProctor);



// WEBPACK FOOTER //
// ./src/app/components/Drawer/EditProctor.js